<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div id="groupModal12" :class="type != '' ? 'modal-mask' : 'modal-mask1'" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop style="max-width: 100%;">
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="modal-body- modal_add_rep d-none-">
                <div class="row mb-2 mt-3">
                  <div class="col-6 pl-4">
                    <div class="h3 d-inline mr-2 text-uppercase">{{ menteeShortName }}</div>
                    <button class="text-uppercase btn btn-primary d-none mentee_title_btn">Apprentice</button>
                  </div>
                  <div class="col-6 pr-4 text-right">
                    <div class="text-muted">Mentor(s)</div>
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item font-weight-bold" v-for="(mentorAssigned, index) in mentorsAssigned" :key="index">{{ mentorAssigned.name }}</li>
                    </ul>                
                  </div>              
                </div>

                <div class="row mb-2 mt-0">
                  <div class="col-6 pl-4">
                    <div class="text-uppercase font-weight-bold">Add Rep</div>
                  </div>
                  <div class="col-6 pr-4 text-right"></div>              
                </div>

                <MenteeAddRepReview 
                  :repTask="repTask" 
                  :menteeFirstName="menteeFirstName"
                  :menteeShortName="menteeShortName"
                  :menteeId = "menteeId"
                  alignApproveDenyBtns="type3"
                  action="add_rep"
                  @closeMenteeAddRepModal="closeMenteeAddRepModal"
                  ref="MenteeAddReviewModal"
                  :isSectionInAdd="isSection"
                ></MenteeAddRepReview>

                <MenteeRepHistory
                  :menteeFirstName="menteeFirstName"
                  :menteeShortName="menteeShortName"
                  :menteeId="menteeId"
                  :taskListId="taskListId"
                  :subTaskId="subTaskId"
                  :taskId="taskId"
                  :isSection="isSection"
                  :tasklistName="tasklistName"
                  :taskName="taskName"
                  :subTasks="subTasks"
                  ref="MenteeRepHistoryModal"
                  @closeMenteeEditRepModal="closeMenteeEditRepModal"
                ></MenteeRepHistory>

              </div>
            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>




  </div>
</template>

<script>
import axios from 'axios';
import MenteeAddRepReview from '@/components/mentee/mentee_rep_review.vue';
import MenteeRepHistory from '@/components/mentee/mentee_rep_history.vue';

export default {
  props: ['isModalVisible'],
  data() {
    return {
      menteeFirstName: '',
      menteeShortName: '',
      mentorsAssigned: [],
      tasklistName: '',
      taskName: '',
      repTask: {},
      subTasks: [],
      taskListId: '',
      subTaskId: '',
      taskId: '',
      menteeId: '',
      isSection: 'no',
      subtaskIndex: '',
      type: '',

    }
  },
  computed: {
    
  },
  methods: {
    hide() {
      let showSubTasks = this.$refs['MenteeAddReviewModal'].showSubTasks;
      if (showSubTasks) {
        this.$refs['MenteeAddReviewModal'].toggleShowSubTasks();
      }

      this.$refs['MenteeAddReviewModal'].resetRepForm();
      this.$emit('closeMenteeAddRepModal', this.subtaskIndex, this.type);
    },
    closeMenteeAddRepModal(flag = 0) {
      this.$emit('closeMenteeAddRepModal', this.subtaskIndex, this.type, flag);
    },
    closeMenteeEditRepModal() {
      this.$emit('closeMenteeEditRepModal', this.subtaskIndex, this.type);
    },
    getRepData(taskListId, subTaskId, taskId, menteeId, isSection,subtaskIndex, type) {
      this.taskListId = taskListId;
      this.subTaskId = subTaskId;
      this.taskId = taskId;
      this.menteeId = menteeId;
      this.isSection = isSection;
      this.subtaskIndex = subtaskIndex;
      this.type = type;
      this.subTasks = [];
      setTimeout(() => {
        let element = document.getElementById('groupModal12');    
        element.scrollIntoView(true);
      }, 2000);
      axios('/desktop/v2/manager/get-add-rep-detail', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          tasklist_id: this.taskListId,
          subtask_id: this.subTaskId,
          task_id: this.taskId != 0 ? this.taskId : '',
          mentee_id: this.menteeId,
          is_section: this.isSection,
        }
      })
      .then(resp => {
        let data = resp.data;
        this.menteeFirstName = data.mentee_first_name;
        this.menteeShortName = data.mentee_short_name;
        this.mentorsAssigned = data.mentors_assigned;
        this.tasklistName = data.tasklist_name;
        this.taskName = data.task_name;

        this.repTask = {
          taskListId: this.taskListId,
          subtask_id: this.subTaskId,
          taskListName: this.tasklistName,
          taskName: data.task_name,        
        };
        if (this.isSection == 'yes') {
          this.repTask.subtaskTasks = data.sub_tasks;
          this.subTasks = data.sub_tasks;
        } else {
          this.repTask.taskId = this.taskId;
        }

        this.$refs.MenteeRepHistoryModal.getRepHistory(this.taskListId, this.subTaskId, this.taskId, this.menteeId, this.isSection, this.menteeFirstName, this.menteeShortName, this.tasklistName, this.taskName, this.subTasks);
        this.$refs.MenteeAddReviewModal.checkIsSection();
      })
      .catch(() => {});

    },
  },
  components: {
    MenteeAddRepReview,
    MenteeRepHistory,
  },
  created() {
  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}


::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/mentee/mentee_add_rep.vue